/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams, useParams } from "react-router";
import {
  Button,
  Form,
  SelectionField,
  MultiSelectionField,
  InputField,
  MultiSelectField,
  RadioInputField,
  TextAreaField,
  RichTextField,
  VisualizationAttr,
  Spinner,
  
  
} from "@/commons/components";
import {
  ALLOWED_PERMISSIONS,
  findAllowedPermission,
} from "@/commons/constants/allowedPermission";
import cleanFormData from "@/commons/utils/cleanFormData";
import saveKelasDosen from '../services/saveKelasDosen'

import { notifyError, notifySuccess} from "@/commons/utils/toaster";
import * as Layouts from "@/commons/layouts";

const FormTambahDosenKelas = ({ 
	dosen
 }) => {
  const { 
    control, 
    handleSubmit,
  } = useForm({ defaultValues: dosen })
  
  
  const { kelasId } = useParams()
  
  const navigate = useNavigate()
  
  const tambah = (data) => {
    const cleanData = cleanFormData(data)
    saveKelasDosen({
	  kelasId: kelasId,
      ...cleanData,
    })
    .then(({ data: { data } }) => {
     navigate(`/kelas/${kelasId}`)
  	notifySuccess(`Save Kelas Dosen berhasil!`);
    })
    .catch((error) => {
      console.error(error);
          notifyError(error);
    });
  }
  
  
  return (
	<div>
	  <Layouts.FormComponentLayout
		  title="Tambah Dosen Kelas" 
		  onSubmit={handleSubmit(tambah)}
	
	    vas={[
		  ]}
	
		  formFields={[
			<Controller
				key="dosenId"
				name="dosenId"
				control={control}
				render={({ field, fieldState }) => (
						<SelectionField
					
					label="Dosen"
					options={dosen}
					optionKey="dosenId"
					optionLabel="dosen"
					placeholder="Masukkan dosen"
						fieldState={fieldState}
						defaultValue={dosen.dosenId}
					{...field}
						isRequired={false}
				/>
		
				)}
			/>
			,			  
			  <Controller
			    key="bobot"
		        name="bobot"
		        control={control}
		        render={({ field, fieldState }) => (
				  <InputField
		            label="Bobot"
		            placeholder="Masukkan bobot"
					type="number"
		            defaultValue={dosen.bobot}	            fieldState={fieldState}
					{...field}
					isRequired={false}
		          />
		        )}
		      />
		  ]}
	
		  itemsEvents={[
				<Button id="_CNKZEC5WEfCJ1YDat3KRPQ" key="Tambah" type="submit" variant="primary">Tambah</Button>
	    ]}
	  />
	    
	</div>
  )
}

export default FormTambahDosenKelas
